import collab from '@/redux/requests/collab.js';

export const getPrefs = (opts = {}, callback) => {
  return collab.get('/v1/pieve/prefs', {
    action: 'GET_PREFS',
    authToken: opts.authToken,
    signal: opts.signal,
    callback
  });
};

export const setPref = ({ path, value } = {}, callback) => {
  return collab.put('userPref', {
    resourceId: 'self',
    action: 'SET_PREF',
    data: { path, value },
    callback
  });
};
